function beforeSend (event) {
return event
}

export default beforeSend;